import React, { useEffect } from 'react';

import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { LANDING_PAGE_EVENTS } from 'Utilities/analytics';
import useLoadExternalScripts from 'Utilities/hooks/useLoadScripts';

import { Content } from 'Components/legacy/sbcra/Content/Content';

import LocalTexts from './HeaderForm.texts.json';

import styles from './HeaderForm.scss';

const LocalT = new MDText(LocalTexts);

export const HeaderForm: React.FC = () => {
  const { handleExternalScript } = useLoadExternalScripts();

  useEffect(() => {
    handleExternalScript({ scripts: ['https://embed.typeform.com/next/embed.js'] });
  }, [handleExternalScript]);

  useEffect(() => {
    (window as any).drivingGlovesReady = () => {
      LANDING_PAGE_EVENTS.SECTION_LOAD({
        label: 'driving_gloves',
        name: 'hero',
      });
    };

    (window as any).drivingGlovesSubmit = () => {
      LANDING_PAGE_EVENTS.DRIVING_GLOVES_SUBMIT();
    };

    return () => {
      delete (window as any).drivingGlovesReady;
      delete (window as any).drivingGlovesSubmit;
    };
  }, []);

  const link = <Hyperlink href='/blog/2026/06/25/driving-gloves-prize-draw' label={LocalT.translate('termsLink')} />;

  return <section className={styles.headerForm}>
    <Content>
      <div className={styles.headerContent}>
        <h1 className={styles.title}>{LocalT.translate('title')}</h1>
        <p data-thc-style-override>{LocalT.translate('content')}</p>
        <p data-thc-style-override className={styles.terms}>{LocalT.translate('terms', { link })}</p>
      </div>
      <div className={styles.formContainer}>
        <div data-tf-live="01KTRKFJKEKBWJCE13PF7PZSFK" data-tf-on-ready="drivingGlovesReady" data-tf-on-submit="drivingGlovesSubmit" />
      </div>
    </Content>
  </section>;
};
